import { useTranslation } from "react-i18next";
import { Link } from "../../../router/LocaleLink";
import { Paths } from "../../../router/paths";
import styles from "./etfDetail.module.css";

/** Not found / failed state for /etf/:symbol (rendered by the route's ErrorBoundary). */
export const EtfDetailError = ({ title, text }: { title: string; text: string }) => {
  const { t } = useTranslation();
  return (
    <main className={styles.errorPage}>
      <h1>{title}</h1>
      <p>{text}</p>
      <Link to={Paths.ETF_SCREENER} className={styles.backLink}>
        {t("pages.etfDetail.backToScreener")}
      </Link>
    </main>
  );
};
